export default __webpack_public_path__ + "static/media/0064.deb9767f.png";